export default __webpack_public_path__ + "static/media/destination3.af3b8976.jpg";